module.exports = __webpack_public_path__ + "static/media/image-bus-popup.96fea331.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/santajuana/image-bus-popup.png
// module id = 1687
// module chunks = 0